import { render, staticRenderFns } from "./ViewIncidenciaPage.vue?vue&type=template&id=2fa47cb6"
import script from "./ViewIncidenciaPage.vue?vue&type=script&lang=js"
export * from "./ViewIncidenciaPage.vue?vue&type=script&lang=js"
import style0 from "./ViewIncidenciaPage.vue?vue&type=style&index=0&id=2fa47cb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports